export const GenerateImageFormat: {[key: string]: Array<string>} = {
    Profile: [
        'alpha=-15',
        'beta=20',
        'projectionMode=Orthographic',
        'enable2D=true',
        'enable3D=true',
        'enable2DZBuffer=true',
        'height=392',
        'width=392',
        'zoom=40',
        'format=png',
        'hideSubArticles=false',
        'autoSmooth=true',
        'enableShaders=true',
        'ambient=0.50 0.50 0.50',
        'fadeBorder=10',
        'shadowPlane=false',
        'shadowPlane.smoothness=0.04',
        'shadowPlane.border=0',
        'shadowPlane.color=0.1 0.1 0.1',
        'shadowPlane.filter=Linear',
        'shadowPlane.mapSize=400',
        'shadowPlane.maxHeight=0.04'
    ]
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/GenerateImageFormats.ts